<template>
    <div class="history">
      <div class="row mt-5 mb-5">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Reporte devoluciones {{ provider.name }}</h5>
              <!-- {{user}} -->
              <!-- <pre>
                {{items}}
              </pre> -->
              <div class="row justify-content-end" v-if="selected.length > 0">
                <button class="btn btn-purple" @click="printEtiquetas">Imprimir etiquetas</button>
              </div>
              <div class="row justify-content-center mt-5 mb-4">
                <input type="date" v-model="dateI" name="fechaInicial">
                <input type="date" v-model="dateF" name="fechaFinal" class="mt-1 ml-2">
                <button class="btn btn-secondary ml-3" @click="loadItems">Buscar</button>
              </div>
              <!-- {{selected}} -->
              <b-table
                selectable
                class="table-adelantazo"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                @row-selected="onRowSelected"
                selectedVariant="success"
                show-empty
                stacked="md"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <!-- <template
                  v-slot:cell(date)="row"
                >{{ getDateFormatEpoch(row.item.date) }}</template> -->
                <template v-slot:cell(total)="row">
                  <div align="center" class="history-amount">
                    <span v-html="getFormattedAmount(row.item)" />
                  </div>
                </template>
                <template v-slot:cell(action)="row">
                  <div align="center" class="history-amount">
                      <button class="btn btn-purple" @click="showDetail(row)">Detalle</button>
                  </div>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <!-- <div slot="RequestDate" slot-scope="row">{{ row }}</div> -->
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <!-- <pre>
        {{tickets}}
      </pre> -->
      <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="`Labels-Order`"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="letter"
          :htmlToPdfOptions = "htmlToPdfOptions"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          ref="html2Pdf"
        >
          <section slot="pdf-content">
            <section class="pdf-item labelsComplete">
              <div class="etiqueta col" v-for="(item, index) in tickets" :key="item.id_order">
                <div v-bind:class="[index > 2 ? 'row justify-content-center mt-1' : 'row justify-content-center']">
                  <!-- <VueBarcode :value="item.barcode" format="Codabar"  textPosition="top" :options="barcode_option" height="30" width="2" font-size="10"/> -->
                  <VueBarcode :value="item.barcode" format="CODE39"  textPosition="top" :options="barcode_option" height="40" width="1" font-size="9"/>
                </div>
                <div class="row justify-content-center printLabels">
                  <div class="col-lg-10 text-left">
                    <p><b>{{item.key_client}}</b> - {{item.name}} {{item.lastname}} {{item.lastname2}} </p>
                    <p><b>{{ item.key_provider + item.siglas}}</b> - {{item.marca}} - {{item.modelo}} - {{item.color}} - {{item.numero}} </p>
                    <p class="endLabels"><b>{{item.sucursal}}</b> - Compra: {{item.date_buy}}</p>
                  </div>
                </div>
              </div>
            </section>
          </section>
        </vue-html2pdf>
    </div>
  </template>
<script>
import { BTable } from 'bootstrap-vue'
import getTimeFormat from '@/mixins/getTimeFormat'
import axiosAdelaService from '@/axios/axiosAdelaService'
import { mapGetters } from 'vuex'
import VueHtml2pdf from 'vue-html2pdf'
import VueBarcode from 'vue-barcode'
import moment from 'moment-timezone'
moment().tz('America/Mexico_city').format()
export default {
  mixins: [getTimeFormat],
  components: {
    BTable,
    VueHtml2pdf,
    VueBarcode
  },
  data () {
    return {
      provider: [],
      tickets: [],
      barcode_option: {
        lineColor: '#0aa'
      },
      htmlToPdfOptions: {
        margin: [12, 0, 12, 0],
        filename: 'algo',
        html2canvas: {
          scale: 3,
          useCORS: true
        }
      },
      selectMode: 'multi',
      selected: [],
      dateI: moment().format('YYYY-MM-DD'),
      dateF: moment().format('YYYY-MM-DD'),
      items: [],
      fields: [
        { key: 'folio', label: 'Folio', sortable: true, sortDirection: 'desc' },
        // { key: 'barcode', label: 'Codigo de barras', sortable: true, sortDirection: 'desc' },
        { key: 'cantidad', label: 'Cantidad de Productos', sortable: true, sortDirection: 'desc' },
        { key: 'total', label: 'Total de Devolución', sortable: true, sortDirection: 'desc' },
        { key: 'status', label: 'Estatus', sortable: true, sortDirection: 'desc' },
        { key: 'create_at', label: 'Fecha de Devolución', sortable: true, sortDirection: 'desc' },
        { key: 'action', label: 'Detalle' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    onRowSelected (items) {
      this.selected = items
    },
    showDetail (row) {
      console.log('este es el Row', row)
      this.$router.push({ name: 'genrealDevolutionsDetail', params: row })
    },
    getFormattedAmount (row) {
      if (row) {
        return '$ ' + this.$formatNumberCurrency(row.total, 'MXN') + ' <span class="mxn">MXN</span>'
      } else {
        return ''
      }
    },
    async loadItems () {
      try {
        const params = {
          fechaI: this.dateI,
          fechaF: this.dateF,
          provider_id: this.$route.params.provider_id
        }
        console.log('parametros', params)
        const response = await axiosAdelaService.post('/getDevolutionProvider', params)
        console.log('getDevolutionProvider', response)
        if (response.status === 200) {
          const x = response.data.rows
          x.forEach(el => {
            el.create_at = moment(el.create_at).format('YYYY-MM-DD')
            el.status = el.cantidad > 0 ? 'Activo' : 'CANCELADO'
            if (el.cantidad <= 0) {
              el._rowVariant = 'danger'
            }
          })
          this.items = x
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    },
    async printEtiquetas () {
      try {
        this.tickets = []
        const params = {
          tickets: this.selected,
          enterprise: this.user.enterprise_id
        }
        console.log('parametros', params)
        const response = await axiosAdelaService.post('/searchTiketForBuys', params)
        console.log('GetBarcodesforTicket', response)
        if (response.status === 200) {
          const data = response.data
          for (const key in data) {
            for (const key2 in data[key]) {
              console.log('fecha de compra', moment(data[key][key2].date_buy).format('YYYY-MM-DD'))
              data[key].date_buy = moment(data[key][key2].date_buy).format('YYYY-MM-DD')
              this.tickets.push(data[key][key2])
            }
          }
          this.$refs.html2Pdf.generatePdf()
        }
      } catch (error) {
        this.showError('No se pudieron obtener el historial intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    console.log('this.$route.params', this.$route.params)
    this.loadItems(this.$route.params)
  }
}
</script>
<style>
.etiqueta {
    width: 66mm !important;
    height: 25mm !important;
    /* background: black;s */
    padding: 0px !important;
}
.labels {
    width: 60mm;
    font-size: 9px;
}
.labels p {
    line-height: 1;
    margin: 0;
}
.labelsComplete {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
/* grid-auto-rows: minmax(66mm, auto); */
}
</style>
